<!-- Loading bar -->
<!--<fuse-loading-bar></fuse-loading-bar>-->

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full h-16 sm:h-15 px-4 md:px-6 z-49
     shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden test" fxLayout="row">

        <div fxFlex="20">
<!--            <div fxLayout="row">-->
<!--                <mat-icon-->
<!--                    class="ml-2 icon-size-5 text-center"-->
<!--                    [svgIcon]="'mat_solid:arrow_back_ios'"></mat-icon>-->
<!--                <span class="text-m text-center font-medium tracking-tight text-secondary" *ngIf="!isScreenSmall">Back-->
<!--                </span>-->
<!--            </div>-->
        </div>

        <div fxFlex="60">
            <div class="text-l text-center font-medium tracking-tight text-secondary">Participant Project Calculations</div>
        </div>

        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2" *ngIf="isScreenSmall" fxFlex="20">
            <button
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto w-full">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>
</div>

